// import './modal.scss';

export { default } from './Modal';
export { default as template } from './modal.tpl';
